import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';

import { Logger } from '@core/services';
import { isMobileView } from '@core/utils';
import { CredentialsService } from '@app/auth';

const log = new Logger('AuthenticationGuard');

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class AlreadyLoggedCheckGuard {
  private readonly _credentialsService = inject(CredentialsService);
  private readonly _router = inject(Router);

  async canActivate(): Promise<boolean> {
    const isAuthenticated = this._credentialsService.isAuthenticated();
    if (isAuthenticated) {
      let url = '/dashboard';
      if (isMobileView()) {
        url = '/m/dashboard';
      }
      this._router.navigateByUrl(url);
      return false;
    } else {
      return true;
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  private readonly _router = inject(Router);
  private readonly _credentialsService = inject(CredentialsService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this._credentialsService.isAuthenticated()) {
      return true;
    }

    log.debug('Not authenticated, redirecting and adding redirect url...');
    this._router.navigate(['/login'], { queryParams: { redirect: state.url }, replaceUrl: true });
    return false;
  }
}
